module.exports = __webpack_public_path__ + "static/media/modal-cadastro-pet-sucess.374d210d.png";